// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"b9f7d8e1","186":"368086ce","225":"eda9fedf","272":"f4d82758","372":"7b68ee38","377":"5ea24877","573":"31577b53","738":"1b4dd1b4","841":"a9a8b2f2","856":"121437d0"}[chunkId] + ".chunk.js";
};